import React, { useEffect, useState } from 'react';
import Table, { buttonsStyle } from "../app/components/tables/table";
import { getDataBlocks } from './structuresCalcs';
import { alertError } from './logger';
import EditPatientTramIntakeDialog from '../app/components/dialogs/userCompetitions/EditPatientTramIntakeDialog';
import { Card, CardBody } from '../_metronic/_partials/controls';
import { Col, Row } from 'react-bootstrap';
import OnlyText from '../app/components/textFields/OnlyText';
import ConfirmDialog from '../app/components/dialogs/ConfirmDialog';
import { deleteSpecificsTramsXUser, getTramsCompetitionUser } from '../api/tramXuser';
import { useSkeleton } from '../app/hooks/useSkeleton';
import { Edit } from '@material-ui/icons';
import { Button, TextField, Tooltip } from '@material-ui/core';
import MyAutocomplete from '../app/components/MyAutocomplete';
import { getCompetitions } from '../api/competition';
import { getSportFoods } from '../api/sportFood';
import { getMins, formatHourMins, formatFloat, getHours } from './helpers';
import { getNts, isLiquid } from './sportFoodUtils';
import OnlyTextMult from '../app/components/textFields/OnlyTextMult';

export const competitionColor = "#F64E60";

export function calcCompetitionData(competition) {
    let positiveUnevenness = 0;
    let negativeUnevenness = 0;
    let totalKilometers = 0;

    const trams = competition?.trams || [];
    for (let i = 0; i < trams.length; ++i) {
        const actT = trams[i];
        positiveUnevenness += parseFloat(actT?.positiveUnevenness) || 0;
        negativeUnevenness += parseFloat(actT?.negativeUnevenness) || 0;
        totalKilometers += parseFloat(actT?.longitude) || 0;
    }

    return {
        ...competition,
        positiveUnevenness: positiveUnevenness,
        negativeUnevenness: negativeUnevenness,
        totalKilometers: totalKilometers
    }
}

function sortByNumber(a, b) {
    if (a.number < b.number) return -1;
    if (a.number > b.number) return 1;
    return 0;
}

export function calcsFoods(definedTram, time) {
    const foods = definedTram?.foods;

    let choG = 0;
    let sodiumMg = 0;
    let sodiumMgL = 0;
    let waterMl = 0;
    let caffeine = 0;
    
    for (let i = 0; i < foods?.length; ++i) {
        const actF = foods[i];
        const nts = getNts(actF.food, actF?.ml, actF?.quantity);
        waterMl += nts?.waterMl || 0;
        choG += nts?.choG || 0;
        sodiumMg += nts?.sodiumMg || 0;
        sodiumMgL += nts?.sodiumMgL || 0;
        caffeine += nts?.caffeine || 0;
    }

    let choGH = 0, waterMlH = 0;
    if (time) {
        const hours = time / 60;
        choGH = (choG / hours); 
        waterMlH = (waterMl / hours);
        sodiumMgL = waterMl ? (sodiumMg / (waterMl/1000)) : 0;
    }
    
    return { waterMl, waterMlH, choG, choGH, sodiumMg, sodiumMgL, caffeine }
}

function calcSweatRate(competition) {
    let sweatR = 0;
    // console.log(competition)
    for (let i = 1; i <= 3; ++i) sweatR += parseFloat(competition[`sweatRate${i}`] || 0) * getHours(competition[`time${i}`] || "0");
    return sweatR;
}

function calcTotalTime(tramsXuser, competition) {
    let time = 0;
    const lastTram = tramsXuser?.find((x) => parseFloat(x.numTram) === competition?.trams?.length-1);
    if (lastTram?.elapsedTime) return getMins(lastTram?.elapsedTime);
    // for (let i = 1; i <= 3; ++i) time += getMins(competition[`time${i}`] || "0");
    return time;
}

function calcHidrics(patient, competition, tramsXuser, completeCompetition) {
    let tbwPost = 0, sweatL = 0, hydrationRate = 0;
    const dh = parseFloat(competition?.dh)/100 || 0; 
    const weight = patient?.actualWeight;
    const time = (calcTotalTime(tramsXuser, completeCompetition)/60) || 1;

    const bwLoss = weight * dh;
    tbwPost = weight - bwLoss;

    sweatL = calcSweatRate(competition);

    const waterReq = (sweatL - bwLoss) * 1000;
    hydrationRate = waterReq / time;

    return { tbwPost, sweatL, hydrationRate, waterReq };
}

function calcAvgPace(time, kms) {
    if (!time || !kms) return '';
    // console.log(getMins(time) / parseFloat(kms))
    return (getMins(time) / parseFloat(kms));
}

function calcArrival(totalTime, startTime) {
    if (!totalTime || !startTime) return '';
    const totalMins = getMins(totalTime);
    const startMins = getMins(startTime);
    const sum = totalMins + startMins;
    return formatHourMins(sum, true);
}

export function calcSplitTime(tram, tramsXuser) {
    const elapsedAct = getMins(tram?.elapsedTime);
    
    const tramN = parseFloat(tram?.numTram || 0);
    const nextTram = tramsXuser.find((x) => parseFloat(x.numTram) === tramN + 1);
    const elapsedNext = getMins(nextTram?.elapsedTime);

    const res = (elapsedNext - elapsedAct)
    return (res < 0) ? 0 : res;
}

export function calcElapsedTime(timeOfDay, initTime) {
    const minsAct = getMins(timeOfDay);
    const minsInit = getMins(initTime);        
    if (minsAct < minsInit) return -(minsInit - minsAct) + 24*60;
    return minsAct - minsInit;
}

export function  calcTimeOfDay(elapsedTime, initTime) {
    const minsAct = getMins(elapsedTime);
    const minsInit = getMins(initTime);        
    return minsAct + minsInit;
}

export const InfoPatientCompetition = (props) => {
    const { 
        userId, openEditTramUserDialog, setOpenEditTramUserDialog,
        competition, setCompetition, competitions,
        tramsXuser, setTramsXuser, date, patient, inDiet
     } = props;

    const [refresh, setRefresh] = useState(false);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(-1);
	const [selectedCompetition, setSelectedCompetition] = useState(null);
    const [competitionOptions, setCompetitionOptions] = useState([]);
    const [completeCompetition, setCompleteCompetition] = useState(null);
    const [allCompetitions, setAllCompetitions] = useState([]);
    const [selectedTram, setSelectedTram] = useState(null);
    const [foods, setFoods] = useState([]);
    const [foodOptions, setFoodOptions] = useState([]);
    const [nutritionals, setNutritionals] = useState(null);
    const [columnsInfo, setColumnsInfo] = useState([]);

	const {
		isLoading: isLoadingData,
		disableLoading: disableLoadingData,
		ContentSkeleton,
	} = useSkeleton();

    function getEmptyTram() {
        return {
            _id: undefined,
            numTram: '',
            name: '',
            idClient: userId,
            idCompetition: competition?.competitionId,
            foods: [],
            extrInfo: ''
        };
    }

    useEffect(() => {setRefresh(false);}, [refresh]);
    useEffect(() => {actualizeTimeCalcs(tramsXuser, competition, completeCompetition);}, [tramsXuser, completeCompetition]);

    useEffect(() => {
        if (competitions?.length !== 0) actualizeCompetitionOptions(competitions)
    }, [competitions])

    useEffect(() => {
        getCompetitions()
            .then((res) => {
                const complete = res.data.find((x) => x._id === competition.competitionId);
                setCompleteCompetition(complete);
                refreshNutritionals(complete);
                setAllCompetitions(res.data);
                disableLoadingData();
            })
            .catch((error) => {
                alertError({
                    error: error,
                    customMessage: "Could not get all the information about the competition"
                })
            })

    	if (foods?.length === 0) {
			getSportFoods()
				.then((res) => {
					if (res.status === 200) {
						setFoods(res.data);
						actualizeFoodOptions(res.data);
                        if (inDiet) disableLoadingData();
					}
				})
				.catch((error) => {
					alertError({
						error: error,
						customMessage: "Could not get foods.",
					});
				});
		}
	
    }, [])

    useEffect(() => {
        refreshNutritionals(completeCompetition);
    }, [competition, tramsXuser])

    function refreshNutritionals(completeCompetition) {
        let totals = { waterMl: 0, waterMlH: 0, choG: 0, choGH: 0, sodiumMg: 0, sodiumMgL: 0, caffeine: 0};
        const comp = competitions.find((x) => x._id === competition.competitionId)
        const trams = comp?.trams;
        
        function sumNt(element, calcs, elem) {
            elem[element] = calcs[element];
            totals[element] += calcs[element];
        }

        function sortByNumber(a, b) {
            if (a.number > b.number) return 1;
            if (a.number < b.number) return -1;
            return 0;
        }

        let data = [];

        for (let i = 0; i < trams?.length; ++i) {
            let elem = {};
            const act = trams[i];
            const index = tramsXuser?.findIndex((x) => parseInt(x.numTram) === act.number)
            const definedTram = tramsXuser[index]
            
            elem.name = act.name;
            elem.number = act.number;
            elem.longitude = act?.longitude;
			elem.elapsedTime = definedTram?.elapsedTime || "";
            if (parseFloat(elem.number) === 0) elem.elapsedTime = '00:00';
            elem.positiveUnevenness = act?.positiveUnevenness;
            elem.negativeUnevenness = act?.negativeUnevenness;
            elem.foods = definedTram?.foods;
            
            const time = calcSplitTime(definedTram, tramsXuser, competition);
            // const time = calcTimeBtwTrams(definedTram, index, tramsXuser, competition);
			// elem.splitTime = splitTime;
            let timeOfDay = "";
            if (definedTram?.elapsedTime) timeOfDay = formatHourMins(calcTimeOfDay(definedTram?.elapsedTime, completeCompetition?.departTime), true);
            else if (parseFloat(act?.number) === 0) timeOfDay = completeCompetition?.departTime;
            
            elem.time = timeOfDay;
            const calcs = calcsFoods(definedTram, parseFloat(time || 1));

            sumNt("waterMl", calcs, elem);
            sumNt("choG", calcs, elem);
            sumNt("sodiumMg", calcs, elem);
            sumNt("caffeine", calcs, elem);
            elem.choGH = calcs.choGH;
            elem.waterMlH = calcs.waterMlH;
            elem.sodiumMgL = calcs.sodiumMgL;

            data.push(elem);
        }

        data.sort(sortByNumber)

        const { tbwPost, sweatL, hydrationRate, waterReq } = calcHidrics(patient, competition, tramsXuser, completeCompetition);
        const totalTime = (calcTotalTime(tramsXuser, completeCompetition)/60) || 1;//competition?.totalTime ? getHours(competition.totalTime) : 1;
        const L = totals.waterMl / 1000;
        setNutritionals({
            ...totals,
            choGH: totals.choG / totalTime,
            waterMlH: totals.waterMl / totalTime,
            sodiumMgL: L ? (totals.sodiumMg / L) : 0,

            //Hidrics
            tbwPost,
            sweatL,
            hydrationRate,
            waterReq
        });
        setColumnsInfo(data);
    }

	function actualizeFoodOptions(foods) {
		let data = [];

		for (let i = 0; i < foods?.length; ++i) {
			const actF = foods[i];
			data.push({
                ...actF,
                name: actF?.fullName?.es
            })
		}
		setFoodOptions(data);
	}

    const statusOptions = ["En espera dels temps de pas", "Preparada per planificar", 
        "En procés de planificació", "Planificada", "Realitzada"];

    function getTramsTableData(tramsXuser) {
    }

    const numberFormatWidth = { width: '96px' };
    const tramsTable = [
        {
            dataField: "name",
            text: "title",
            headerStyle: { width: '200px' }
        },
		{ 
			dataField: "longitude", 
			text: "Distance (km)",
			formatter: fixedOne,
			headerAlign: "center",
			align: "center",
            headerStyle: numberFormatWidth
		},
		{ 
			dataField: "positiveUnevenness", 
			text: "Elevation gain (m)",
			formatter: fixedZero,
			headerAlign: "center",
			align: "center",
            headerStyle: numberFormatWidth
		},
        { 
			dataField: "negativeUnevenness", 
			text: "Elevation loss (m)",
			formatter: fixedZero,
			headerAlign: "center",
			align: "center",
            headerStyle: numberFormatWidth
		},
        { 
			dataField: "elapsedTime", 
			text: "elapsed time",
			// formatter: unevennessFormater,
			headerAlign: "center",
			align: "center",
            headerStyle: { width: '78px' }
		},
        { 
			dataField: "time", 
			text: "time of day",
			// formatter: unevennessFormater,
			headerAlign: "center",
			align: "center",
            headerStyle: { width: '70px' }
		},
        {
            dataField: "choGH",
            text: "CHO (g/h)",
            align: 'center',
            headerAlign: "center",
            formatter: fixedZero,
            headerStyle: numberFormatWidth
        },
        {
            dataField: "waterMlH",
            text: "water (ml/h)",
            align: 'center',
            headerAlign: "center",
            formatter: fixedZero,
            headerStyle: numberFormatWidth
        },
        {
            dataField: "sodiumMgL",
            text: "na (mg/l)",
            align: 'center',
            headerAlign: "center",
            formatter: fixedZero,
            headerStyle: numberFormatWidth
        },
        {
            dataField: "caffeine",
            text: "caf",
            align: 'center',
            headerAlign: "center",
            formatter: fixedZero,
            headerStyle: numberFormatWidth
        },
        {
            dataField: "number",
            text: "Intake",
            formatter: intakesFormatter,
            align: "left",
            headerAlign: 'left'
        },
        {
            dataField: "number",
            text: "",
            formatter: tramsButtonFormatter,
            align: "right",
            headerStyle: { width: '80px' }
        }
    ]

    function fixedZero(cell) {return parseFloat(cell).toFixed(0);}
    function fixedOne(cell) {return parseFloat(cell).toFixed(1);}

    function intakesFormatter(cell, row) {
        let text = ``;
        const foods = row?.foods;
        for (let i = 0; i < foods?.length; ++i) {
            const actF = foods[i];
            text += `${(i !== 0 ? " // " : "")}`
            if (isLiquid(actF?.food)) text += `${actF?.ml || 0} mL`;
            else text += `${actF?.quantity || 0} ud`;
            text += ` ${actF?.food?.fullName?.es}`
        }
        return text;
    }

    function foodsFormatter(cell) {
        let text = "no intake";

        if (cell?.length > 0) {
            text = cell[0].name;
            for (let i = 1; i < cell?.length; ++i) {
                const actF = cell[i];
                text += "<br>" + actF.name;
            }
        }
    
        return <span dangerouslySetInnerHTML={{ __html: text }} />;
    }

    function observationsFormatter(cell) {
        let text = "";

        if (cell?.length > 0) {
            text = cell[0].observations;
            for (let i = 1; i < cell?.length; ++i) {
                const actF = cell[i];
                text += "<br>" + actF.observations;
            }
        }
    
        return <span dangerouslySetInnerHTML={{ __html: text }} />;
    }

	function tramsButtonFormatter(cell, row) {
        let index = tramsXuser?.findIndex((x => parseFloat(x.numTram) === parseFloat(cell)));
        let tram = tramsXuser[index];
		if (!tram) tram = {...getEmptyTram(), name: row.name, numTram: row.number};

        return (
			<>
                <Tooltip title="Edit tram info">
                    <Button
                        style={buttonsStyle}
                        size="small"
                        onClick={() => {
                            setOpenEditTramUserDialog(true);
                            setSelectedTram({...tram, ...row});
                        }}
                    >
                        <Edit />
                    </Button>
                </Tooltip>
            </>
		)
	}
    
    function actualizeCompetitionOptions(competitions) {
        let data = [];

		data.push({
			competitionId: -1,
			competitionName: "None"
		})

        for (let i = 0; i < competitions?.length; ++i) {
            let elem = {};
            const act = competitions[i];

            elem.competitionId = act._id;
            elem.competitionName = act.fullName.es;

            data.push(elem);
        }

        setCompetitionOptions(data);
    }

    function setSalida(trams, competition, completeCompetition) {
        let newTrams = [...trams], encontrado = false;
        for (let i = 0; i < newTrams?.length; ++i) {
            const actTram = newTrams[i];
            if (actTram?.numTram === 0) {encontrado = true; break;}
        }
        
        if (!encontrado) newTrams.push({
            numTram: 0,
            idClient: userId,
            idCompetition: competition?.competitionId,
            foods: [],
            time: completeCompetition?.departTime,
            date: competition?.date
        })
        return newTrams;
    }

    function actualizeTimeCalcs(tramsXuser, competition, completeCompetition) {
        let newCompetition = {...competition};
        const totalTime = formatHourMins(calcTotalTime(tramsXuser, completeCompetition));
        newCompetition.totalTime = totalTime;
        newCompetition.avgPace = calcAvgPace(totalTime, completeCompetition?.totalKilometers);
        newCompetition.arrivalTime = calcArrival(totalTime, completeCompetition?.departTime);
        setCompetition(newCompetition);
    }

    function actualizeTramsData(competition, completeCompetition) {
        if (userId && (date?.dateStr ? date?.dateStr : true) && competition?.competitionId && competition?.competitionId !== -1) 
			getTramsCompetitionUser(competition?.competitionId, userId, date.dateStr)
				.then((res) => {
					if (res.status === 200) {
                        const newTrams = setSalida(res.data, competition, completeCompetition);
						setTramsXuser(newTrams);
                        actualizeTimeCalcs(newTrams, competition, completeCompetition)
                        console.log(newTrams)
						// disableLoadingData();
					}
				})
				.catch((error) => {
                    const newTrams = setSalida([], competition, completeCompetition);
                    console.log(newTrams)
                    setTramsXuser(newTrams);
					console.log("No hay tramos");
				});
    }

    function actualizeCompetition(selected) {
		if (competition?.competitionId && competition?.competitionId !== -1) { 
			deleteSpecificsTramsXUser(competition?.competitionId, userId, competition.date)
				.then((res) => {
					if (res.status === 204) {

					}
				})
				.catch((error) => {
					alertError({
						error: error,
						customMessage: "There was a problem actualizing the trams information"
					})
				})
		}
		const newCompetition = {
            ...competition,
			competitionId: selected.competitionId,
			competitionName: selected.competitionName
		}
        console.log(newCompetition, allCompetitions)
        const complete = allCompetitions.find((x) => x._id === newCompetition.competitionId);
        setCompleteCompetition(complete);
        if (userId) actualizeTramsData(newCompetition, complete);
		setCompetition(newCompetition);
		// actualizeTramsData(newCompetition);
		// setChanges(changes+1);
		setRefresh(true)
	}

    function formatGutTolerance(value) {
        if (!value) return "Undefined..."
		switch (parseFloat(value)) {
			case 1: return "1 - No symptoms";
			case 2: return "2 - Mild symptoms";
			case 3: return "3 - Severe symptoms";
			default: return value;
		}
	}

    const UserFeedback = () => {
        const fb = competition?.userFeedback;

        return (
            <>
                <h4>Feedback</h4>
                <Row>
                    <Col>
                        <TextField
                            id={`feedbackTime`}
                            label="Total time"
                            value={`${fb?.totalTime ? fb.totalTime : "Not defined by the user..."}`}
                            inputProps={{ readOnly: true }}
                            required
                            margin="normal"
                            variant="standard"
                            type="text"
                            className="readonly"
                        />
                    </Col>
                    <Col>
                        <TextField
                            id={`gastroentinals`}
                            label="Gut tolerance"
                            value={formatGutTolerance(fb?.gastroentinals)}
                            inputProps={{ readOnly: true }}
                            required
                            margin="normal"
                            variant="standard"
                            type="text"
                            className="readonly"
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TextField
                            id={`notes`}
                            label="Notes"
                            value={`${fb?.notes ? fb.notes : "Not defined by the user..."}`}
                            inputProps={{ readOnly: true }}
                            required
                            margin="normal"
                            variant="standard"
                            type="text"
                            className="readonly"
                            multiline
                        />
                    </Col>
                </Row>
            </>
        )
    }

    function handleChange(element, value) {
        let newCompetition = { ...competition, [element]: value }

        setCompetition(newCompetition);
        setRefresh(true);
    }

    function ReadOnly(title, value) {
        return (
            <TextField
                id={`${title}`}
                label={title}
                value={formatFloat(nutritionals[value])}
                inputProps={{ readOnly: true }}
                required
                margin="normal"
                variant="standard"
                type="number"
                className="readonly"
            />
        )
    }

    function NutritionalValues() {
        
        return (
            <>
                <br />
                <Row>
                    <Col><h4>Intake</h4></Col>
                </Row>
                <Row>
                    <Col>{ReadOnly("Water (mL)", "waterMl")}</Col>
                    <Col>{ReadOnly("Water (mL/h)", "waterMlH")}</Col>
                    <Col>{ReadOnly("CHO (g)", "choG")}</Col>
                    <Col>{ReadOnly("CHO (g/h)", "choGH")}</Col>
                    <Col>{ReadOnly("Na (mg)", "sodiumMg")}</Col>
                    <Col>{ReadOnly("Na (mg/L)", "sodiumMgL")}</Col>
                    <Col>{ReadOnly("Caf", "caffeine")}</Col>
                </Row>
            </>
        )
    }
    
    function formatMMSS(value) {
        if (!value) return;
        const fl = parseFloat(value);
        const m = Math.floor(fl);
        let s = Math.floor((fl%1) * 60)
        if (s < 10) s = "0" + s;
        return `${m}:${s}`;
    }

    function formatDate(data) {
        const date = new Date(data);
        let d = date.getDate();
        let m = date.getMonth() + 1;
        if (d < 10) d = "0" + d;
        if (m < 10) m = "0" + m;
        const y = date.getFullYear();
        return `${d}/${m}/${y}`;
    }

    if (isLoadingData) return (<ContentSkeleton />)
    return (<>
        <ConfirmDialog
            title={
            "Are you sure you want to change the competition? You will lose all your changes"
            }
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
                actualizeCompetition(selectedCompetition)
                setOpenConfirmDialog(-1);
            }}
        />
        <Card>
            <CardBody>
                <Row>
                    <Col>
                        <MyAutocomplete
                            options={ competitionOptions }
                            getOptionLabel={(option) =>
                                option.competitionName
                            }
                            value={ competitionOptions.find(option => option.competitionId === competition?.competitionId) || null }
                            onChange={(event, selected) => {
                                if (!competition?.competitionId || competition?.competitionId === -1) actualizeCompetition(selected);
                                else {
                                    setOpenConfirmDialog(2)
                                    setSelectedCompetition(selected);
                                }
                            }}
                            placeholder="Select competition"
                            label={"Type of competition"}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <MyAutocomplete 
                            options={ statusOptions }
                            getOptionLabel={(option) =>
                                option
                            }
                            value={ statusOptions.find(option => option === competition?.status) || null }
                            onChange={(event, selected) => {
                                setCompetition({
                                    ...competition,
                                    status: selected
                                })
                            }}
                            placeholder="Select status competition"
                            label={"Status competition"}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TextField
                            id={`location`}
                            label="Location"
                            value={completeCompetition?.location}
                            inputProps={{ readOnly: true }}
                            required
                            margin="normal"
                            variant="standard"
                            type="text"
                            className="readonly"
                        />
                    </Col>
                    <Col>
                        <TextField
                            id={`compType`}
                            label="Competition type"
                            value={completeCompetition?.competitionType?.fullName?.es}
                            inputProps={{ readOnly: true }}
                            required
                            margin="normal"
                            variant="standard"
                            type="text"
                            className="readonly"
                        />
                    </Col>
                    <Col>
                        <TextField
                            id={`date`}
                            label="Date"
                            value={formatDate(competition?.date)}
                            inputProps={{ readOnly: true }}
                            required
                            margin="normal"
                            variant="standard"
                            type="text"
                            className="readonly"
                        />
                    </Col>
                    <Col>
                        <TextField
                            id={`startTime`}
                            label="Start time"
                            value={completeCompetition?.departTime}
                            inputProps={{ readOnly: true }}
                            required
                            margin="normal"
                            variant="standard"
                            type="time"
                            className="readonly"
                        />
                    </Col>
                    <Col>
                        <TextField
                            id={`distance`}
                            label="Distance (km)"
                            value={completeCompetition?.totalKilometers}
                            inputProps={{ readOnly: true }}
                            required
                            margin="normal"
                            variant="standard"
                            type="text"
                            className="readonly"
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TextField
                            id={`ascent`}
                            label="Ascent (km)"
                            value={completeCompetition?.accumulatedPositiveSlope}
                            inputProps={{ readOnly: true }}
                            required
                            margin="normal"
                            variant="standard"
                            type="text"
                            className="readonly"
                        />
                    </Col>
                    <Col>
                        <TextField
                            id={`ascent`}
                            label="Descent (km)"
                            value={completeCompetition?.accumulatedNegativeSlope}
                            inputProps={{ readOnly: true }}
                            required
                            margin="normal"
                            variant="standard"
                            type="text"
                            className="readonly"
                        />
                    </Col>
                    <Col>
                        <TextField
                            id={`weatherPred`}
                            label="Weather prediction"
                            value={completeCompetition?.meteorologicalPrevision}
                            inputProps={{ readOnly: true }}
                            required
                            margin="normal"
                            variant="standard"
                            type="text"
                            className="readonly"
                        />
                    </Col>
                    <Col>
                        <TextField
                            id={`temp`}
                            label="Temperature (ºC)"
                            value={completeCompetition?.temp}
                            inputProps={{ readOnly: true }}
                            required
                            margin="normal"
                            variant="standard"
                            type="text"
                            className="readonly"
                        />
                    </Col>
                    <Col>
                        <TextField
                            id={`relativeHum`}
                            label="Realtive humidity"
                            value={completeCompetition?.relativeHumidity}
                            inputProps={{ readOnly: true }}
                            required
                            margin="normal"
                            variant="standard"
                            type="text"
                            className="readonly"
                        />
                    </Col>
                </Row>
                <Row>
                    <Col sm={4}>
                        <TextField
                            id={`mediumPace`}
                            label="Total time"
                            value={competition?.totalTime}
                            inputProps={{ readOnly: true }}
                            required
                            margin="normal"
                            variant="standard"
                            type="text"
                            className="readonly"
                        />
                        {/* <OnlyText title="Total time" element="totalTime" data={competition} specific={false} type="time"
                            handleChange={() => (event) => {
                                handleChange("totalTime", event.target.value);
                            }}	
                        /> */}
                    </Col>
                    <Col sm={4}>
                        { completeCompetition && 
                        <TextField
                            id={`mediumPace`}
                            label="Avg pace (min/km)"
                            value={formatMMSS(competition?.avgPace)}
                            inputProps={{ readOnly: true }}
                            required
                            margin="normal"
                            variant="standard"
                            type="text"
                            className="readonly"
                        />
                        }
                    </Col>
                    <Col sm={4}>
                        { completeCompetition && 
                        <TextField
                            id={`arrivalTime`}
                            label="Arrival time"
                            value={competition?.arrivalTime}
                            inputProps={{ readOnly: true }}
                            required
                            margin="normal"
                            variant="standard"
                            type="time"
                            className="readonly"
                        />
                        }
                    </Col>
                </Row>

                <br />
                <Row><Col><h4>Requirements</h4></Col></Row>
                {/* <HidricRequirements /> */}
                <Row>
                    <Col>
                        <OnlyText title="Sweat rate 1 (L/h)" element="sweatRate1" data={competition} specific={false} type="number"
                            handleChange={() => (event) => {
                                handleChange("sweatRate1", event.target.value);
                            }}	
                        />
                    </Col>
                    <Col>
                        <OnlyText title="Time 1" element="time1" data={competition} specific={false} type="time"
                            handleChange={() => (event) => {
                                handleChange("time1", event.target.value);
                            }}	
                        />
                    </Col>
                    <Col>
                        <OnlyText title="Sweat rate 2 (L/h)" element="sweatRate2" data={competition} specific={false} type="number"
                            handleChange={() => (event) => {
                                handleChange("sweatRate2", event.target.value);
                            }}	
                        />
                    </Col>
                    <Col>
                        <OnlyText title="Time 2" element="time2" data={competition} specific={false} type="time"
                            handleChange={() => (event) => {
                                handleChange("time2", event.target.value);
                            }}	
                        />
                    </Col>
                    <Col>
                        <OnlyText title="Sweat rate 3 (L/h)" element="sweatRate3" data={competition} specific={false} type="number"
                            handleChange={() => (event) => {
                                handleChange("sweatRate3", event.target.value);
                            }}	
                        />
                    </Col>
                    <Col>
                        <OnlyText title="Time 3" element="time3" data={competition} specific={false} type="time"
                            handleChange={() => (event) => {
                                handleChange("time3", event.target.value);
                            }}	
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <OnlyText title="%DH" element="dh" data={competition} specific={false} type="number"
                            handleChange={() => (event) => {
                                handleChange("dh", event.target.value);
                            }}	
                        />
                    </Col>
                    <Col>
                        <TextField
                            id={`sweatL`}
                            label="Sweat (L)"
                            value={formatFloat(nutritionals?.sweatL)}
                            inputProps={{ readOnly: true }}
                            required
                            margin="normal"
                            variant="standard"
                            type="number"
                            className="readonly"
                        />
                    </Col>
                    <Col>
                        <TextField
                            id={`hydrationRate`}
                            label="Hydration Rate (mL/h)"
                            value={formatFloat(nutritionals?.hydrationRate)}
                            inputProps={{ readOnly: true }}
                            required
                            margin="normal"
                            variant="standard"
                            type="number"
                            className="readonly"
                        />
                    </Col>
                    <Col>
                        <TextField
                            id={`waterReq`}
                            label="Total water req (mL)"
                            value={formatFloat(nutritionals?.waterReq || 0).toFixed(0)}
                            inputProps={{ readOnly: true }}
                            required
                            margin="normal"
                            variant="standard"
                            type="number"
                            className="readonly"
                        />
                    </Col>
                </Row>

                <NutritionalValues />
                
                <br />
                <Row>
                    <Col><h4>Sections</h4></Col><Col/><Col/>
                    <Col />
                </Row>
                <br/>
                {!refresh && (
                    <Table 
                        columns={tramsTable}
                        data={columnsInfo}
                    />
                )}
                <br />
                <Row>
                    <Col>
                        <OnlyTextMult title="Comments" element="comments" data={competition} specific={false}
                            handleChange={() => (event) => {
                                handleChange("comments", event.target.value);
                            }}	
                        />
                    </Col>
                </Row>
                <br />
                <UserFeedback />
            </CardBody>
        </Card>

        <EditPatientTramIntakeDialog 
            open={openEditTramUserDialog}
            setOpen={setOpenEditTramUserDialog}
            data={selectedTram}
            userId={userId}
            competitionId={competition?.competitionId}
            competition={competition}
            completeCompetition={completeCompetition}
            foods={foods}
            setFoods={setFoods}
            foodOptions={foodOptions}
            setFoodOptions={setFoodOptions}
            tramsXuser={tramsXuser}

            onSave={(intakeTram) => {
                let newTrams = [...tramsXuser];

                const index = tramsXuser?.findIndex((x) => x.numTram === intakeTram.numTram);
                if (index === -1) newTrams.push(intakeTram);
                else newTrams[index] = intakeTram;
                
                setTramsXuser(newTrams);
                actualizeTimeCalcs(newTrams, competition, completeCompetition)
                setRefresh(true);
            }}
        />
        
    </>)
}

export const tramsTable = [
    {
        dataField: "name",
        text: ""
    },
    {
        dataField: "longitude",
        text: "KM",
        headerAlign: "center",
        align: "center"
    },
    {
        dataField: "positiveUnevenness",
        text: "D+",
        headerAlign: "center",
        align: "center"
    },
    {
        dataField: "negativeUnevenness",
        text: "D-",
        headerAlign: "center",
        align: "center"
    },
    {
        dataField: "time",
        text: "Tiempo",
        headerAlign: "center",
        align: "center"
    },
    {}
]

export function getDataTrams(trams, tramsXuser) {

    let data = [];

    for (let i = 0; i < trams?.length; ++i) {
        let elem = {};
        const actT = trams[i];

        const definedTram = tramsXuser?.find((x) => parseInt(x?.numTram) === actT.number)

        elem.number = actT?.number;
        elem.name = actT?.name;
        elem.longitude = actT?.longitude;
        elem.positiveUnevenness = actT?.positiveUnevenness;
        elem.negativeUnevenness = actT?.negativeUnevenness;
        
        elem.time = definedTram?.time || "0";

        data.push(elem);
    }
    
    data.sort(sortByNumber)
    return data;
}

export const BlocksTable = React.memo((props) => {
    const { blocks, setNt, patient } = props;

    const [dataBlocks, setDataBlocks] = useState([]);

    useEffect(() => {
        if (blocks) getDataB(blocks);
    }, [blocks])

    const blockColumns = [
        {
            dataField: "number",
            text: "type",
            formatter: typeFormatter,
        },
        {
            dataField: "kcals",
            text: "kcal",
            formatter: numbersFormatter,
            align: 'center',
            headerAlign: 'center',
        },
        {
            dataField: "carbohydrates",
            text: "cho",
            formatter: numbersFormatter,
            align: 'center',
            headerAlign: 'center',
        },
        {
            dataField: "proteins",
            text: "pro",
            formatter: numbersFormatter,
            align: 'center',
            headerAlign: 'center',
        },
        {
            dataField: "fats",
            text: "fat",
            formatter: numbersFormatter,
            align: 'center',
            headerAlign: 'center',
        },
        {
            dataField: "fiber",
            text: "fiber",
            formatter: numbersFormatter,
            align: 'center',
            headerAlign: 'center',
        },
    ];
    
    function numbersFormatter(cell) {return cell.toFixed(1);}
    
    function typeFormatter(cell) {
        const block = blocks.find((x) => cell === x.number);
        return (block?.isIntake? block?.intake.isSnack? "Snack" : "Main" : "Exercise");
    }

    async function getDataB(blocks) {
        const dataBlocks = await getDataBlocks(blocks, patient);
		setDataBlocks(dataBlocks.data);
        delete dataBlocks.data;
        setNt(dataBlocks);
    }

    return (<Table data={dataBlocks} columns={blockColumns} hideSearchTable={true} hidePagination={true}/>)
}, (prevProps, nextProps) => {
    return prevProps === nextProps;
})

//Punto 4
export const IntakesCompetitionTable = React.memo((props) => {
    const { tramsXuser } = props;

    const [dataIntakes, setDataIntakes] = useState([]);

    useEffect(() => {
        if (tramsXuser) getDataI(tramsXuser);
    }, [tramsXuser])

    const foodColumns = [
        {
            dataField: "name",
            text: ""
        },
        {
            dataField: "grams",
            align: 'center',
            headerAlign: 'center',
            text: "grams"
        },
        {
            dataField: "kcals",
            text: "kcal",
            align: 'center',
            headerAlign: 'center',
        },
        {
            dataField: "carbohydrates",
            text: "cho",
            formatter: numbersFormatter,
            align: 'center',
            headerAlign: 'center',
        },
        {
            dataField: "proteins",
            text: "pro",
            formatter: numbersFormatter,
            align: 'center',
            headerAlign: 'center',
        },
        {
            dataField: "fats",
            text: "fat",
            formatter: numbersFormatter,
            align: 'center',
            headerAlign: 'center',
        }
    ];
    
    function numbersFormatter(cell) {return cell.toFixed(1);}

    async function getDataI(tramsXuser) {
        const foodIds = [...new Set(tramsXuser.flatMap(item => item.foods.map(food => food.food)))];
        
        let data = [];

        for (let i = 0; i < foodIds?.length; ++i) {
            let elem = {};
            const food = foodIds[i];
            if (food) {
                elem.name = food.fullName.es;
                elem.kcals = parseFloat(food?.kcals);
                elem.carbohydrates = parseFloat(food?.carbohydrates);
                elem.proteins = parseFloat(food?.proteins);
                elem.fats = parseFloat(food?.fats);
                elem.fiber = parseFloat(food?.fiber);
                elem.grams = 100;
            }

            data.push(elem);
        }

		setDataIntakes(data);
    }
    // return (<></>)
    return (<Table data={dataIntakes} columns={foodColumns} hideSearchTable={true} hidePagination={true}/>)
}, (prevProps, nextProps) => {
    return prevProps === nextProps;
})

//Punto 6
export const NutritionalBag = React.memo((props) => {
    const { trams, tramsXuser } = props;

    const [dataIntakes, setDataIntakes] = useState([]);

    useEffect(() => {
        if (tramsXuser) getDataI(tramsXuser);
    }, [tramsXuser])

    const tramsColumns = [
        {
            dataField: "quantity",
            text: "quantity",
        },
        {
            dataField: "name",
            text: "name",
            align: 'center',
            headerAlign: "center"
        },
        {
            dataField: "type",
            text: "product",
            align: 'center',
            headerAlign: "center",
            formatter: typeFormatter
        },
    ]
    
    function typeFormatter(cell, row) {
        return cell;
    }

    async function getDataI(tramsXuser) {

        async function getFood(food) {
            return food.food;
        }

        const uniqueFoodsMap = new Map();

        for (const item of tramsXuser) {
            for (const food of item.foods) {
                if (!uniqueFoodsMap.has(food.food)) {
                    const definedFood = await getFood(food);
                    uniqueFoodsMap.set(food.food, { ...food, definedFood });
                } else {
                    const existingFood = uniqueFoodsMap.get(food.food);
                    existingFood.quantity += food.quantity || 0;
                    existingFood.grams += food.grams || 0;
        
                    uniqueFoodsMap.set(food.food, existingFood);
                }
            } 
        }

        let data = [];

        uniqueFoodsMap.forEach((food) => {
            let elem = {};
            
            elem._id = food.food;
            if (food?.selectedPortion >= 0) {
                const defF = food.definedFood;
                const portion = defF?.portions?.find((x) => x._id === food.selectedPortion);
                elem.quantity = `${food.quantity} ${portion.name}`;
            } else elem.quantity = `${food.grams} grams`;
            elem.name = food.name;
            elem.type = food.name;

            data.push(elem);
        })

		setDataIntakes(data);
    }
    // return (<></>)
    return (<Table data={dataIntakes} columns={tramsColumns} hideSearchTable={true} hidePagination={true}/>)
}, (prevProps, nextProps) => {
    return prevProps === nextProps;
})

//Punto 7
export const DistributionIntakesTable = React.memo((props) => {
    const { trams, tramsXuser } = props;

    const [dataIntakes, setDataIntakes] = useState([]);

    useEffect(() => {
        if (tramsXuser) getDataI(tramsXuser);
    }, [tramsXuser])

    const tramsColumns = [
        {
            dataField: "name",
            text: "title"
        },
        {
            dataField: "foods",
            text: "quantity",
            align: 'center',
            headerAlign: "center",
            formatter: quantityFormatter
        },
        {
            dataField: "foods",
            text: "food",
            align: 'center',
            headerAlign: "center",
            formatter: foodsFormatter
        },
        {
            dataField: "foods",
            text: "observations",
            align: 'center',
            headerAlign: "center",
            formatter: observationsFormatter
        },
    ]

    function quantityFormatter(cell, row) {

        function getFoodInfoText(food, definedFoods) {
            if (food?.selectedPortion >= 0) {
                const actDF = definedFoods?.find((x) => x._id === cell[0].food)
                const quantityName = actDF?.portions?.find((x) => x._id === cell[0].selectedPortion)
                return cell[0].quantity + " " + quantityName.name;
            } else return cell[0].grams + " grams";
        }
        let text = "";
        const definedFoods = row?.definedFoods;

        if (cell?.length > 0) {
            text += getFoodInfoText(cell[0], definedFoods);
            for (let i = 1; i < cell?.length; ++i) text += "<br>" + getFoodInfoText(cell[i], definedFoods);
        }
    
        return <span dangerouslySetInnerHTML={{ __html: text }} />;
    }

    function foodsFormatter(cell) {
        let text = "no intake";

        if (cell?.length > 0) {
            text = cell[0].name;
            for (let i = 1; i < cell?.length; ++i) {
                const actF = cell[i];
                text += "<br>" + actF.name;
            }
        }
    
        return <span dangerouslySetInnerHTML={{ __html: text }} />;
    }

    function observationsFormatter(cell) {
        let text = "";

        if (cell?.length > 0) {
            text = cell[0].observations;
            for (let i = 1; i < cell?.length; ++i) {
                const actF = cell[i];
                text += "<br>" + actF.observations;
            }
        }
    
        return <span dangerouslySetInnerHTML={{ __html: text }} />;
    }

    async function getFoods(foods) {
        let data = [];
        for (let i = 0; i < foods?.length; ++i) {
            data.push(foods[i].food)
        }
        return data;
    }

    async function getDataI(tramsXuser) {
        let data = [];

        for (let i = 0; i < trams?.length; ++i) {
            let elem = {};
            const act = trams[i];
            const definedTram = tramsXuser?.find((x) => parseInt(x.numTram) === act.number)
            const definedFoods = await getFoods(definedTram?.foods);
            
            elem.name = act.name;
            elem.number = act.number;
            elem.foods = definedTram?.foods || [];
            elem.definedFoods = definedFoods || [];

            data.push(elem);
        }

        data.sort(sortByNumber)

		setDataIntakes(data);
    }
    // return (<></>)
    return (<Table data={dataIntakes} columns={tramsColumns} hideSearchTable={true} hidePagination={true}/>)
}, (prevProps, nextProps) => {
    return prevProps === nextProps;
})